import React from 'react';
export function HawxSection() {
  return <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden mb-12 transition-shadow hover:shadow-lg" data-id="element-1346">
      <div className="flex flex-col md:flex-row" data-id="element-1347">
        <div className="md:w-5/12 p-8 flex items-center justify-center bg-gray-50 border-b md:border-b-0 md:border-r border-gray-100" data-id="element-1348">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20Hawx.jpg" alt="HAWX" className="block max-w-full h-auto object-contain max-h-[300px]" data-id="element-1349" />
        </div>
        <div className="md:w-7/12 p-8 flex flex-col" data-id="element-1350">
          <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-tight mb-2" data-id="element-1351">
            HAWX
          </h3>
          <h4 className="text-lg font-semibold text-navy mb-4 leading-snug" data-id="element-1352">
            High-Dynamic 5-Axis Vertical Gantry Monoblock Machining Center
          </h4>
          <div className="text-gray-700 mb-6 flex-grow space-y-4" data-id="element-1353">
            <p className="leading-relaxed" data-id="element-1354">
              The right combination of robustness and stability makes the
              machine ideal for{' '}
              <strong data-id="element-1355">
                milling and trimming operations at high speed on parts with
                complex 3D shapes
              </strong>{' '}
              made of{' '}
              <strong data-id="element-1356">lightweight alloy, resin, or composite materials.</strong>
            </p>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 text-sm" data-id="element-1357">
              <strong className="text-navy block mb-2" data-id="element-1358">Travels (X,Y,Z):</strong>
              <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-1359">
                <li data-id="element-1360">X: 157 - 236 in.</li>
                <li data-id="element-1361">Y: 75 in.</li>
                <li data-id="element-1362">Z: 51 in.</li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-auto pt-4 border-t border-gray-100" data-id="element-1363">
            <a href="https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=Breton%20Hawx" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1364">
              <span className="mr-2" data-id="element-1365">+</span> Request Quote
            </a>
            <a href="https://www.breton.it/products/machines-and-lines/breton-hawx-e1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1366">
              <span className="mr-2" data-id="element-1367">+</span> Additional Information
            </a>
          </div>
        </div>
      </div>
    </div>;
}